import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import "./articles.scss";

const Articles = (props) => {
  let variantName = "";
  if (props.variantName1) {
    variantName = props.variantName1;
  } else if (props.variantName2) {
    variantName = props.variantName2;
  } else if (props.variantName3) {
    variantName = props.variantName3;
  } else if (props.variantName4) {
    variantName = props.variantName4;
  } else {
    variantName = props.variantName1;
  }
  return (
    <Container fluid className="d-sm-block">
      <Row className="article-container">
        <Col className="col-left-align" xs={12} sm={4} md={4} lg={4}></Col>
        <Col
          className={`col-right-align ${variantName}`}
          xs={12}
          sm={8}
          md={8}
          lg={8}
        >
          <p>{`Understanding how your TPT pension is invested.`}</p>
          <Buttons
            className=" d-sm-block btn-find-out mt-3"
            name="Find out how"
            iconname="arrow-right"
            variantname="icon-sixteen-px"
            handleClick={() => (window.location = "#/learn")}
          />
          {/* <Buttons
            className="outline-light"
            handleClick={() => (window.location = "#/manage/av-contribution")}
            iconname="arrow-right-white"
            variantname="icon-sixteen-px"
            name="Continue to AVC"
          /> */}
        </Col>
      </Row>
    </Container>
  );
};

export default Articles;
